
import { Component, Prop, Vue, Watch } from "vue-property-decorator"
import { Getter, Action, namespace } from "vuex-class"

const featuresStore = namespace("features")

	@Component({
		components: {}
	})
export default class ZendeskHelp extends Vue {
		@Prop({ type: Boolean, default: false }) public iconOnly!: boolean
		@Prop({ type: Boolean, default: false }) public widgetOnly!: boolean

		@featuresStore.Getter("getOpsZendeskHelpWidgetEnabled") private zendeskWidgetEnabled!: boolean
		@featuresStore.Getter("getOpsZendeskHelpWidgetInitialized") private zendeskWidgetInitialized!: boolean
		@featuresStore.Action("getOpsZendeskHelpWidgetEnabledSetting") private getZendeskWidgetEnabled!: () => Promise<void>

		private renderZendeskWidgetInterval: NodeJS.Timeout | null = null;
		private autoHideClosedWidgetInterval: NodeJS.Timeout | null = null;

		private zendeskWidgetInjected: boolean = false

		private async mounted (): Promise<void> {
			if (!this.zendeskWidgetInitialized) {
				await this.getZendeskWidgetEnabled()
			}
			if (this.zendeskWidgetEnabled && !this.zendeskWidgetInjected) {
				this.injectZendeskScript(this.zendeskWidgetEnabled)
			}
		}

		private beforeDestroy (): void {
			if (this.renderZendeskWidgetInterval) {
				clearInterval(this.renderZendeskWidgetInterval)
			}
			if (this.autoHideClosedWidgetInterval) {
				clearInterval(this.autoHideClosedWidgetInterval)
			}
		}

		private toggleHelp (): void {
			if (document.querySelector("#webWidget")) {
				// hide the widget
				this.renderZendeskWidget()
			} else {
				window.zE("webWidget", "helpCenter:setSuggestions", {
					url: true
				})
				window.zE("webWidget", "show")
				window.zE("webWidget", "open")
				this.startWidgetAutoHide()
			}
		}

		private startWidgetAutoHide (): void {
			if (this.autoHideClosedWidgetInterval) {
				clearInterval(this.autoHideClosedWidgetInterval)
			}
			this.autoHideClosedWidgetInterval = setInterval(() => {
				if (!document.getElementById("webWidget")) {
					try {
						this.renderZendeskWidget()
					} catch {
						// Suppress exception
					} finally {
						if (this.autoHideClosedWidgetInterval) {
							clearInterval(this.autoHideClosedWidgetInterval)
						}
					}
				}
			}, 500)
		}

		@Watch("zendeskWidgetEnabled")
		private zendeskWidgetEnabledStateChanged (enabledState: boolean) {
			this.injectZendeskScript(enabledState)
		}

		private injectZendeskScript (enabledState: boolean):void {
			if (enabledState) {
				let zendeskSnippetWrapper = document.getElementById("ze-snippet-wrapper")
				let existingZendeskSnippetScript = document.getElementById("ze-snippet")

				if (zendeskSnippetWrapper && !existingZendeskSnippetScript) {
					let zendeskSnippetScript = document.createElement("script")
					zendeskSnippetScript.setAttribute("id", "ze-snippet")
					zendeskSnippetScript.setAttribute("src", "https://static.zdassets.com/ekr/snippet.js?key=f2079635-f990-4427-87b4-84c8ffd2e959")

					zendeskSnippetWrapper.appendChild(zendeskSnippetScript)
					this.zendeskWidgetInjected = true
				} else if (existingZendeskSnippetScript) {
					this.zendeskWidgetInjected = true // contingency for if we want multiple buttons to display.
				}
			}

			this.renderZendeskWidgetTimed()
		}

		private get zendeskHelpWidgetAvailable () {
			return this.zendeskWidgetEnabled && this.zendeskWidgetInjected
		}

		private renderZendeskWidget (): void {
			if (this.$route && this.$route.name === "login" && this.zendeskHelpWidgetAvailable) {
				window.zE("webWidget", "show")
			} else {
				// hide the help button
				window.zE("webWidget", "hide")
			}
		}

		private renderZendeskWidgetTimed (): void {
			if (typeof (window.zE) === "function") {
				this.renderZendeskWidget()
			} else {
				if (this.renderZendeskWidgetInterval) {
					clearInterval(this.renderZendeskWidgetInterval)
				}
				this.renderZendeskWidgetInterval = setInterval(() => {
					if (window && window.zE) {
						try {
							this.renderZendeskWidget()
						} catch {
							// Suppress exception
						} finally {
							if (this.renderZendeskWidgetInterval) {
								clearInterval(this.renderZendeskWidgetInterval)
							}
						}
					}
				}, 50)
			}
		}
}
